import script from "./info-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./info-dialog.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__